export enum VideoSource {
  Unknown = 'unknown',
  Youtube = 'youtube',
  Vimeo = 'vimeo',
  Upload = 'upload',
}
